module.exports = __webpack_public_path__ + "fc03cfcac09d30547e814bf7581c0fe0.png";